export const INTERNAL_ROUTE_ROLES = {
  alum: ['alum'],
  internal: ['admin', 'outreach', 'clinical', 'alum'],
  staff: ['admin', 'outreach', 'clinical'],
  adminOnly: ['admin'],
  generator: ['admin', 'outreach'],
  reporting: ['admin', 'outreach', 'clinical'],
  adminContent: ['admin', 'outreach'],
  adminRsvps: ['admin', 'outreach'],
  adminCheckin: ['admin', 'outreach'],
  eventCheckin: ['admin', 'outreach', 'clinical'],
  photoBooth: ['admin', 'outreach', 'clinical'],
};

export const ALUM_MANAGE_ALL_CAPABILITY = 'alum.manage_all';

const KNOWN_PROFILE_ROLES = new Set([
  'admin',
  'outreach',
  'clinical',
  'alum',
  'pending',
  'disabled',
]);

export function normalizeRole(role) {
  return typeof role === 'string' ? role.trim().toLowerCase() : null;
}

export function normalizeCapability(capability) {
  return typeof capability === 'string' ? capability.trim().toLowerCase() : null;
}

export function hasRequiredRole(role, allowedRoles = []) {
  const normalizedRole = normalizeRole(role);
  if (!normalizedRole) return false;

  return allowedRoles.some((allowedRole) => normalizeRole(allowedRole) === normalizedRole);
}

export function hasProfileCapability(capabilities = [], requiredCapability) {
  const normalizedRequiredCapability = normalizeCapability(requiredCapability);
  if (!normalizedRequiredCapability) return false;

  return (Array.isArray(capabilities) ? capabilities : [])
    .some((capability) => normalizeCapability(capability) === normalizedRequiredCapability);
}

export function getAuthorizationFailureReason(profile, allowedRoles = []) {
  if (!profile) return 'missing_profile';

  const role = normalizeRole(profile.role);
  if (!role) return 'unknown_role';
  if (!KNOWN_PROFILE_ROLES.has(role)) return 'unknown_role';
  if (role === 'pending') return 'pending';
  if (role === 'disabled') return 'disabled';
  if (allowedRoles.length > 0 && !hasRequiredRole(role, allowedRoles)) return 'role_not_allowed';

  return null;
}

export function getDefaultAuthorizedPath(role) {
  if (hasRequiredRole(role, INTERNAL_ROUTE_ROLES.alum)) return '/me/alum';
  if (hasRequiredRole(role, INTERNAL_ROUTE_ROLES.staff)) return '/me';
  if (hasRequiredRole(role, INTERNAL_ROUTE_ROLES.adminCheckin)) return '/admin/checkin';

  return null;
}

export function hasAlumCommandCenterAccess({ role, capabilities = [] } = {}) {
  const normalizedRole = normalizeRole(role);

  if (!normalizedRole || normalizedRole === 'pending' || normalizedRole === 'disabled') {
    return false;
  }

  if (normalizedRole === 'alum') return false;
  if (normalizedRole === 'admin') return true;

  return hasProfileCapability(capabilities, ALUM_MANAGE_ALL_CAPABILITY);
}
